<div class="timer-countdown" dir="ltr" [id]="id">
    <i class="icon-time" style="font-size: 24px; margin-right: 8px;"></i>
    <div style="width: 50px;">
        <span>{{ minutes }}</span>
        <span class="mx-1">:</span>
        <span>{{ sec }}</span>
    </div>
</div>
